import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-gray-600">
          <p className="mb-2">
            Créé avec passion par{' '}
            <a
              href="https://creagencym.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Créagency'M
            </a>{' '}
            {currentYear}
          </p>
          <Link to="/mentions-legales" className="text-gray-500 hover:text-gray-700 text-sm">
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>
  );
}
